<template>
    <div :class="[skeleton, customSize]"></div>
</template>
<script lang="ts" setup>
import { cva } from "class-variance-authority";

interface Props {
    size: "sm" | "md" | "lg" | "xl";
    customSize?: string;
}
// * CVA button class
const skeleton = computed(() => {
    return cva("p-2 loading rounded-lg bg-gray-900", {
        variants: {
            size: {
                sm: "h-[96px] w-[103px]  ",
                md: "h-[138px] w-[148px]",
                lg: "h-[250px] w-[343px]",
                xl: "h-[518px] w-full",
            },
        },
        defaultVariants: { size: "lg" },
    })({
        size: props.size,
    });
});
const props = defineProps<Props>();
</script>
